import React from 'react';
import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import { ICONS_COURSE_CONTAINER_WIDTH } from '@styles/constants/spacings';
import SectionTitle from '@unicons-base/SectionTitle/SectionTitle';
import LessonsListSkeleton from '@unicons-comp/VideoPlayer/LessonsListSkeleton';
import Skeleton from '@unicons-base/Skeleton/Skeleton';
import LessonCard from './LessonCard';

interface LessonsListProps {
  results: any;
  hasActiveSubscription: boolean;
  isCompactCard?: boolean;
  className?: string;
  isLoading?: boolean;
}
const StyledListWrapper = styled.div<{ $isCompactCard?: boolean }>`
  max-width: ${ICONS_COURSE_CONTAINER_WIDTH};
  margin: 0px auto;
  padding: ${({ $isCompactCard }) =>
    $isCompactCard
      ? `${Spacings.SPACING_6B} ${Spacings.SPACING_6B} 0
  ${Spacings.SPACING_6B} `
      : `${Spacings.SPACING_6B} 0 0`}!important;
  ${mediaQuery.uptoTablet} {
    overflow: hidden;
    padding: 0 ${Spacings.SPACING_6B} !important;
  }
`;

const ListWrapper = styled.div<{ $isCompactCard?: boolean }>`
  max-height: ${({ $isCompactCard }) => $isCompactCard && '564px'};
  overflow: auto;
`;

const StyledSectionTitle = styled(SectionTitle)<{ $isCompactCard: boolean }>`
  font-size: ${({ $isCompactCard }) => ($isCompactCard ? Fonts.H5 : Fonts.H4)};
  ${mediaQuery.uptoTablet} {
    margin-top: ${({ $isCompactCard }) =>
      $isCompactCard ? Spacings.SPACING_4B : '0px'};
  }
`;

const LessonsList: React.FC<LessonsListProps> = ({
  results,
  hasActiveSubscription,
  isCompactCard,
  className,
  isLoading
}) => {
  return (
    <StyledListWrapper className={className} $isCompactCard={isCompactCard}>
      {isLoading ? (
        <Skeleton height="20px" width="60%" style={{ marginBottom: '24px' }} />
      ) : (
        <StyledSectionTitle
          $isCompactCard={isCompactCard}
          title={isCompactCard ? 'All lessons' : 'Lessons'}
        />
      )}

      <ListWrapper $isCompactCard={isCompactCard}>
        {isLoading ? (
          <LessonsListSkeleton />
        ) : (
          Array.isArray(results) &&
          results.map((lesson) => (
            <LessonCard
              key={lesson.uuid}
              order={lesson.order}
              duration={lesson.duration}
              title={lesson.title}
              cover={lesson.cover}
              description={lesson.description}
              continueWatching={lesson.continueWatching}
              slug={lesson.slug}
              isComingSoon={lesson.isComingSoon}
              hasActiveSubscription={hasActiveSubscription}
              publishedAt={lesson.publishedAt}
              isCompactCard={isCompactCard}
              bgColor={isCompactCard && 'var(--color-i-icon-dark-primary)'}
            />
          ))
        )}
      </ListWrapper>
    </StyledListWrapper>
  );
};

LessonsList.displayName = 'LessonsList';

LessonsList.defaultProps = {
  isLoading: false
};

export default LessonsList;
